import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7af13d70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delivery-settings-form" }
const _hoisted_2 = { class: "delivery-settings-form__delivery-at delivery-at" }
const _hoisted_3 = {
  for: "delivery-at",
  class: "checkbox delivery-at__checkbox"
}
const _hoisted_4 = ["checked", "disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, " Заказ ко времени ", -1))
const _hoisted_6 = {
  key: 0,
  class: "delivery-at__date date"
}
const _hoisted_7 = { class: "mo-form-group mo-form-group--block date__day" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Дата", -1))
const _hoisted_9 = { class: "mo-form-group mo-form-group--block date__time" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Время", -1))
const _hoisted_11 = {
  key: 0,
  class: "delivery-settings-form__person-count person-count"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "person-count__title" }, " Количество персон ", -1))
const _hoisted_13 = { class: "person-count__control" }
const _hoisted_14 = { class: "person-count__counter" }
const _hoisted_15 = {
  key: 1,
  for: "confirm-by-phone",
  class: "checkbox delivery-settings-form__confirm-by-phone confirm-by-phone"
}
const _hoisted_16 = ["checked"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, " Без подтверждения заказа по телефону ", -1))
const _hoisted_18 = {
  key: 2,
  for: "is-contactless",
  class: "checkbox delivery-settings-form__is-contactless is-contactless"
}
const _hoisted_19 = ["checked"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, " Мне нужна бесконтактная доставка ", -1))
const _hoisted_21 = { class: "delivery-settings-form__notes mo-form-group mo-form-group--line" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Комментарий к заказу", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSelect = _resolveComponent("VueSelect")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createElementVNode("input", {
          id: "delivery-at",
          class: "checkbox__input",
          type: "checkbox",
          checked: _ctx.isDeliveryAtOpen,
          disabled: !!_ctx.cookingTime,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDeliveryAt && _ctx.toggleDeliveryAt(...args)))
        }, null, 40, _hoisted_4),
        _hoisted_5
      ]),
      (_ctx.isDeliveryAtOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_VueSelect, {
                modelValue: _ctx.selectedDay,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDay) = $event)),
                options: _ctx.daysRest,
                label: "title",
                "onOption:selected": _ctx.setDate
              }, {
                "no-options": _withCtx(() => [
                  _createTextVNode(" Дата не найдена ")
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onOption:selected"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_VueSelect, {
                modelValue: _ctx.selectedTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTime) = $event)),
                options: _ctx.workingTimes,
                "onOption:selected": _ctx.setDeliveryAt
              }, {
                "no-options": _withCtx(() => [
                  _createTextVNode(" Время не найдено ")
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onOption:selected"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.orderPlacementOptions.personCountEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.decreasePersonCount && _ctx.decreasePersonCount(...args)))
            }, " - "),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.personCount), 1),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.increasePersonCount && _ctx.increasePersonCount(...args)))
            }, " + ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderPlacementOptions.confirmByPhoneEnabled)
      ? (_openBlock(), _createElementBlock("label", _hoisted_15, [
          _createElementVNode("input", {
            id: "confirm-by-phone",
            class: "checkbox__input",
            type: "checkbox",
            checked: _ctx.confirmByPhone === false,
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleConfirmByPhone && _ctx.toggleConfirmByPhone(...args))),
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateConfirmByPhone && _ctx.validateConfirmByPhone(...args)))
          }, null, 40, _hoisted_16),
          _hoisted_17
        ]))
      : _createCommentVNode("", true),
    (_ctx.orderPlacementOptions.isContactlessEnabled)
      ? (_openBlock(), _createElementBlock("label", _hoisted_18, [
          _createElementVNode("input", {
            id: "is-contactless",
            class: "checkbox__input",
            type: "checkbox",
            checked: _ctx.isContactless,
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleIsContactless && _ctx.toggleIsContactless(...args)))
          }, null, 40, _hoisted_19),
          _hoisted_20
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localNotes) = $event)),
        type: "text",
        class: _normalizeClass({
          'base-input': true,
          'base-input--black': true,
        }),
        onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.debouncedChangeNotes && _ctx.debouncedChangeNotes(...args)))
      }, null, 544), [
        [_vModelText, _ctx.localNotes]
      ])
    ]),
    (_ctx.isOpenPhoneConfirmWarning)
      ? (_openBlock(), _createBlock(_component_ModalDialog, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_Warning, {
              text: _ctx.phoneConfirmWarningMessage,
              "button-text": "Понятно",
              onClick: _ctx.closePhoneConfirmModal
            }, null, 8, ["text", "onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}